import { Constants } from '../../common/Constants';
import KaiaSparkleIcon from '../kaia-sparkle-icon/KaiaSparkleIcon';
import './KaiaShellBanner.css';

/**
 * KaiaBanner Component
 * 
 * Displays an in-shell promotional banner for the KAiA feature.
 * 
 * @param shouldRender - Controls whether the banner should be rendered. If false, returns an empty fragment.
 * 
 * @param {() => void} openKaiaContactForm - Callback function to open the KAiA contact form. The form should have the logic to close itself
 *  
 * @returns A banner component with KAiA branding, informational text, and action buttons,
 *          or an empty fragment if `shouldRender` is false.
 * 
 * @example
 * ```tsx
 * <KaiaBanner 
 *   shouldRender={true} 
 *   openKaiaContactForm={() => setIsDialogOpen(true)} 
 * />
 * ```
 */
const KaiaBanner = ({ shouldRender, openKaiaContactForm }: { shouldRender: boolean, openKaiaContactForm: () => void }) => {
  if (!shouldRender) return <></>;
  return (
    <div className="in-shell-kaia-banner-container kt-ui-app kt-flowbite">
      <div className='in-shell-kaia-banner-info'>
        <div className='in-shell-kaia-banner-info-icon'>
          <KaiaSparkleIcon color='gradient' />
        </div>

        <div className='in-shell-kaia-banner-info-text'>
          <p className='bold in-shell-kaia-banner-info-title'>Make your documents easy to find with KAiA
            <span className='in-shell-kaia-banner-info-label'>beta</span>
          </p>
          <p className='in-shell-kaia-banner-info-subtitle'>Connect your documents to our AI assistant KAiA for quick, smart searches.</p>
        </div>

      </div>
      <div className='in-shell-kaia-banner-actions'>
        <button type='button' onClick={() => openKaiaContactForm()} className="gradient">
          <span >Contact us to get started</span>
        </button>
        <button type='button' className="light" onClick={() => window.open(Constants.KAIA_BANNER_BUTTON_LINK, '_blank', 'noopener,noreferrer')}>
          <KaiaSparkleIcon color='black' />
          <span > Explore KAiA for Inspiration</span>
        </button>
      </div>
    </div>
  )
}

export default KaiaBanner;